// 提现最低金额
export const WITHDRAW_MIN_AMOUNT = 18;
